import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 8000 } }

  connect() {
    this._timer = setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  dismiss() {
    try {
      const alert = bootstrap.Alert.getOrCreateInstance(this.element)
      alert.close()
    } catch (e) {
      // fallback if no bootstrap Alert instance
      this.element.classList.remove('show')
      this.element.addEventListener('transitionend', () => this.element.remove(), { once: true })
    }
  }
}
